<template>
  <ModalContainer queryParam="f018b" ref="modalContainer" size="xl">
    
    <b-card>

      <b-form-checkbox
        switch
      >
        Induccion
      </b-form-checkbox>

      <b-form-checkbox
        switch
      >
        Cirugia
      </b-form-checkbox>

      <b-form-checkbox
        switch
      >
        Anestesia
      </b-form-checkbox>

      <b-form-checkbox
        switch
      >
        Frecuencia Cardiaca
      </b-form-checkbox>

      <b-form-checkbox
        switch
      >
        Temperatura
      </b-form-checkbox>

      <b-form-checkbox
        switch
      >
        PVC
      </b-form-checkbox>

      <Chart018 />

    </b-card>
  </ModalContainer>

</template>

<script>
import { ModalContainer } from '@/shared/components'
import Chart018 from './Form018/Chart018.vue';

export default {

  components: {
    Chart018,
    ModalContainer
  }
}
</script>

<style>

</style>